/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {useCallback, useEffect, useState} from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

// DS
import { VertCarousel, Image } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Product/ProductImageStyles.less';

// UTILS
import generateUUID from 'Utils/generateUUID';

// PRODUCT IMAGE COMPONENT
const ProductImage = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const selectImageHandler = useCallback((image) => {
    setSelectedImage(image);
  }, [ images ]);

  const selectedImageFlag = useCallback((image) => {
    return image === selectedImage ? 'image-selected' : '';
  }, [images]);

  const productImageListDesktop = images.map((item) => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      key={item.id}
      onClick={() => selectImageHandler(item)}
      className={`image-item image-${item.order} ${selectedImageFlag(item)}`}
    >
      <img alt={`Imagem pequena ${item.order} do produto`} src={item.smallImage} />
    </div>
  ));

  const productImageListMobile = images.map((item) => (
    <div
      className={`image-item image-${item.order}`}
      key={generateUUID()}
    >
      <Image
        src={item.mediumImage}
        alt={`Imagem pequena ${item.order} do produto`}
        className="image"
        preview={false}
      />
    </div>
  ));

  useEffect(() => {
    if (images[0]) {
      selectImageHandler(images[0])
    }
  }, [ images ])

  return (
    <div data-testid="product-page-images" className="pdp-image">
      {/* Mobile */}
      <MediaQuery maxWidth={480}>
        <div className="pdp-image-mobile">
          <VertCarousel
            slidesToShow={1}
            variableWidth
          >
            {productImageListMobile}
          </VertCarousel>
        </div>
      </MediaQuery>

      {/* Desktop & Tablet */}
      <MediaQuery minWidth={481}>
        <div className="pdp-image-desktop">
          <div className="product-image-items">
            {images.map((item) => (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                <div
                    key={item.id}
                    onClick={() => selectImageHandler(item)}
                    className={`image-item image-${item.order} ${selectedImageFlag(item)}`}
                >
                  <img alt={`Imagem pequena ${item.order} do produto`} src={item.smallImage} />
                </div>
            )).slice(0, 5)}
          </div>

          <div className="selected-product-image">
            {(() => {
              if (!selectedImage || (!selectedImage?.largeImage && !selectedImage?.mediumImage)) return null;
              return (
                  <img alt="Imagem selecionada do produto" src={selectedImage?.largeImage || selectedImage?.mediumImage} />
              )
            })()}
          </div>
        </div>
      </MediaQuery>
    </div>
  );
};

ProductImage.propTypes = {
  images: PropTypes.array,
};
export default ProductImage;
